/**
 * author:Bai.Zhiming
 * date:客户端一键快签左侧
 */
angular.module("appQuickSignLeftModule", []).
directive("appQuickSignLeft", ["$q", "$state", "$timeout", "trsHttpService", "modalDialog", function($q, $state, $timeout, trsHttpService, modalDialog) {
    return {
        replace: true,
        restirct: "E",
        templateUrl: "./editingCenter/app/quickSign/left/left_tpl.html",
        link: function(scope, $element, $attrs) {
            /**
             * [childrenSelected description] 判断一个节点的子节点是否被选中
             * @param  {[type]} nodesNames [description]
             * @return {[type]}            [description]
             */
            scope.childrenSelected = function(nodesNames) {
                let nodes = nodesNames ? nodesNames.split(",") : [];
                return nodes.indexOf(scope.status.selectedNode) >= 0;
            };
            /**
             * [selectSite description] 切换站点
             * @param  {[type]} site [description] 站点信息
             * @return {[type]}      [description]
             */
            scope.selectSite = function(site) {
                $timeout(() => {
                    getQuickSignSiteAccessAuthority().then(() => {
                        scope.status.nav = {};
                        $state.transitionTo("front.editctr.app.quicksign", { siteid: scope.data.selectedSite.value }, { reload: false })
                        autoLocation();
                    });
                });
                //$state.transitionTo($state.current.name, { siteid: scope.data.selectedSite.value }, { reload: $state.current.name })
            }
            /**
             * [selectNode description] 选中节点
             * @param  {[type]} nodeName [description] 节点名称
             * @return {[type]}          [description]
             */
            scope.selectNode = function(nodeName) {
                scope.status.selectedNode = nodeName;
                $state.go("front.editctr.app.quicksign." + nodeName, "", { reload: "front.editctr.app.quicksign." + nodeName });
            };
            /**
             * [selectSignList description] 选中一键快签列表
             * @param  {[type]} signListType [description] 列表类型
             * @return {[type]}              [description]
             */
            scope.selectSignList = function(signListType) {
                scope.status.selectedNode = "oneclickquicksign";
                scope.status.signListType = signListType;
                $state.go("front.editctr.app.quicksign.oneclickquicksign", { ismine: signListType }, { reload: "front.editctr.app.quicksign.oneclickquicksign" });
            }
            /**
             * [unfold description] 展看收起一级菜单
             * @param  {[type]} navName [description] 菜单名称
             * @return {[type]}         [description]
             */
            scope.unfold = function(navName) {
                scope.status.nav[navName] = !scope.status.nav[navName];
            };
            /**
             * [isUnfold description] 判断一级菜单是否展开
             * @param  {[type]}  navName [description] 菜单名称
             * @return {Boolean}         [description]
             */
            scope.isUnfold = function(navName) {
                return scope.status.nav[navName];
            };
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    nav: {},
                    signListType: $state.params.ismine,
                    quickSignAuthority: [],
                };
                scope.data = {};
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getSites().then(() => {
                    initSelectedSite();
                    getQuickSignSiteAccessAuthority().then(() => {
                        autoLocation();
                    });
                });
            }
            /**
             * [getSites description] 获取站点列表
             * @return {[type]} [description]
             */
            function getSites() {
                let deffer = $q.defer();
                let params = {
                    MediaType: 1,
                    methodname: 'queryWebSitesByMediaType',
                    serviceid: 'mlf_mediasite'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(data => {
                    scope.data.sites = data.DATA.map((item, index) => {
                        return {
                            name: item.SITEDESC,
                            value: item.SITEID
                        }
                    });
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [initSelectedSite description] 初始化选中站点
             * @return {[type]} [description]
             */
            function initSelectedSite() {
                let siteId = $state.params.siteid;
                if (siteId) {
                    scope.data.selectedSite = scope.data.sites.filter((item, index) => {
                        return item.value == siteId;
                    })[0];
                }
                if (!scope.data.selectedSite) {
                    scope.data.selectedSite = angular.copy(scope.data.sites[0]);
                    $state.transitionTo("front.editctr.app.quicksign", { siteid: scope.data.selectedSite.value }, { reload: false })
                }
            }
            /**
             * [getAppSiteAccessAuthority description] 初始化一键快签权限
             * @return {[type]} [description]
             */
            function getQuickSignSiteAccessAuthority() {
                let deffer = $q.defer();
                var params = {
                    serviceid: "mlf_metadataright",
                    methodname: "queryAppSiteOperTypesBySiteId",
                    SiteId: scope.data.selectedSite.value
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    scope.status.quickSignAuthority = handlePermissionData(data);
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [handlePermissionData description] 处理权限数据
             * @return {[type]} [description]
             */
            function handlePermissionData(data) {
                var obj = {};
                for (var i in data) {
                    var array = data[i].split(".");
                    obj[array[1]] = true;
                }
                return obj;
            }
            /**
             * [autoLocation description] 导航自动定位
             * @return {[type]} [description]
             */
            function autoLocation() {
                //无权限则手动添加弹窗提示‘登录用户没有权限访问当前站点的一键快签’
                if (scope.status.quickSignAuthority.relatemanage == undefined && scope.status.quickSignAuthority.audit == undefined && scope.status.quickSignAuthority.quickpub == undefined && scope.status.quickSignAuthority.log == undefined && scope.status.quickSignAuthority.type == undefined) {
                    $state.transitionTo("front.editctr.app.quicksign", { siteid: scope.data.selectedSite.value }, { reload: false })
                    modalDialog.alertType("登录用户没有权限访问站点【" + scope.data.selectedSite.name + "】的一键快签", '', "error", 'confirm', function() {
                        return;
                    });
                }
                $timeout(() => {
                    let curRouter = $state.current.name;
                    if (curRouter === "front.editctr.app.quicksign") {
                        let firstNode = $element.find(".first_level>li>a");
                        if (firstNode.length > 0) firstNode[0].click();
                        let secondNode = $element.find(".first_level>li .second_level li a");
                        if (secondNode.length > 0) secondNode[0].click();
                    } else {
                        let curRouterArray = curRouter.split(".");
                        let selectedNode = curRouterArray[curRouterArray.length - 1];
                        scope.status.selectedNode = selectedNode;
                        if (scope.status.selectedNode == "mymanuscript" || scope.status.selectedNode == "mypush" || scope.status.selectedNode == "allmanuscript" || scope.status.selectedNode == "allpush") {
                            scope.status.nav.manuscriptAssociation = true;
                        }
                        if (scope.status.selectedNode == "manuscriptassociation" || scope.status.selectedNode == "pushassociation") {
                            scope.status.nav.auditCorrelation = true;
                        }
                        if (scope.status.selectedNode == "oneclickquicksign") {
                            scope.status.nav.quickSignList = true;
                        }
                    }
                });
            }
        }
    };
}]);